import Vue from 'vue'
import Router from 'vue-router'
import articleManagerRouter from './modules/articleManager'
// import inspectionManagerRouter from './modules/inspectionManager'
// import qrcodeManagerRouter from './modules/qrcodeManager'
import workOrderManagerRouter from './modules/workOrderManager'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
/* Router Modules */

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    meta: {
      title: '用户登录'
    },
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    hidden: true,
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/admin/index'),
        name: 'dashboard',
        meta: { title: '仪表板', icon: 'el-icon-setting', affix: true }
      }
    ]
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: 'Profile', icon: 'user', noCache: true }
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  {
    path: '/users',
    component: Layout,
    redirect: '/users',
    hidden: true,
    children: [
      {
        path: 'users',
        component: () => import('@/views/manage/users'),
        name: 'users',
        meta: {
          title: '用户管理old',
          icon: 'peoples',
          roles: ['sls_super_manager'] // or you can only set roles in sub nav
        }
      }
    ]
  },
  {
    path: '/provider_manager',
    component: Layout,
    name: 'ProviderManager',
    meta: {
      title: '服务商管理',
      icon: 'el-icon-s-flag',
      roles: ['sls_provider']
    },
    children: [
      {
        path: '/provider_list',
        component: () => import('@/views/provider-manager/provider-list'),
        name: 'provider',
        meta: { title: '服务商', roles: ['sls_provider_list'] }
      },
      {
        path: '/provider_user',
        component: () => import('@/views/provider-manager/provider-user'),
        name: 'providerUser',
        meta: { title: '服务商人员', roles: ['sls_provider_user'] }
      }
    ]
  },
  {
    path: '/service_center',
    component: Layout,
    name: 'ServiceCenter',
    meta: {
      title: '用户管理',
      icon: 'el-icon-s-custom',
      roles: ['sls_center']
    },
    children: [
      {
        path: '/center_user_list',
        component: () => import('@/views/service-center/service-center-user'),
        name: 'CenterUser',
        meta: { title: '中心用户管理', roles: ['sls_center_user'] }
      }
    ]
  },
  {
    path: '/assets',
    component: Layout,
    name: 'Assets',
    meta: {
      title: '设备管理',
      icon: 'el-icon-s-platform',
      roles: ['sls_assets']
    },
    children: [
      {
        path: '/assets_list',
        component: () => import('@/views/assets-manager/assets-list'),
        name: 'AssetsList',
        meta: { title: '设备管理', roles: ['sls_assets_list'] }
      }
    ]
  },
  workOrderManagerRouter,
  {
    path: '/examining_report',
    component: Layout,
    name: 'ExaminingReport',
    meta: {
      title: '检测报告',
      icon: 'el-icon-s-cooperation',
      roles: ['sls_examining_report']
    },
    children: [
      {
        path: 'template',
        component: () => import('@/views/examining-report/template'),
        name: 'ExaminingReportTemplate',
        meta: { title: '报告模板', roles: ['sls_examining_report_template'] }
      },
      {
        path: 'record',
        component: () => import('@/views/examining-report/record'),
        name: 'ExaminingReportRecord',
        meta: { title: '检测记录', roles: ['sls_examining_report_record'] }
      }
    ]
  },
  // customerManagementRouter,
  articleManagerRouter,
  {
    path: '/ad_manager',
    component: Layout,
    name: 'AdvertisementManager',
    meta: {
      title: '广告管理',
      icon: 'el-icon-tickets',
      roles: ['sls_ad']
    },
    children: [
      {
        path: 'advertisement',
        component: () => import('@/views/advertisement-manager/advertisement'),
        name: 'AdList',
        meta: { title: '广告列表', roles: ['sls_ad_list'] }
      },
      {
        path: 'ad_create',
        component: () => import('@/views/advertisement-manager/create'),
        name: 'AdCreate',
        meta: { title: '创建广告', roles: ['sls_ad_create'] }
      },
      {
        path: 'edit/:id(\\d+)',
        component: () => import('@/views/advertisement-manager/edit'),
        name: 'AdEdit',
        meta: { title: '修改广告', noCache: true, roles: ['sls_ad_list'] },
        hidden: true
      },
      {
        path: 'check/:id(\\d+)',
        component: () => import('@/views/advertisement-manager/check'),
        name: 'AdCheck',
        meta: { title: '查看广告', noCache: true, roles: ['sls_ad_check'] },
        hidden: true
      }
    ]
  },
  // inspectionManagerRouter,
  {
    path: '/master_data',
    component: Layout,
    name: 'MasterData',
    meta: {
      title: '主数据管理',
      icon: 'table',
      roles: ['sls_master_data']
    },
    children: [
      {
        path: 'role',
        component: () => import('@/views/customer-management/customer-role'),
        name: 'customerRole',
        hidden: true,
        meta: { title: '角色管理', roles: ['sls_master_data_role'] }
      },
      {
        path: 'assets_type',
        component: () => import('@/views/assets-manager/assets-type'),
        name: 'AssetsType',
        meta: { title: '设备型号', roles: ['sls_master_data_assets_type'] }
      },
      {
        path: 'brakeSystemType',
        component: () => import('@/views/system-manager/brakeSystemType'),
        name: 'BrakeSystemType',
        meta: { title: '制动系统类型', roles: ['sls_master_data_brakeSystemType'] }
      },
      {
        path: 'fault_type',
        component: () => import('@/views/system-manager/faultType'),
        name: 'FaultType',
        meta: { title: '故障类型', roles: ['sls_master_data_fault_type'] }
      },
      {
        path: 'attributionOfLiability',
        component: () => import('@/views/system-manager/attributionOfLiability'),
        name: 'AttributionOfLiability',
        meta: { title: '责任归属', roles: ['sls_master_data_attribution'] }
      },
      {
        path: 'service_items',
        component: () => import('@/views/system-manager/serviceItems'),
        name: 'ServiceItems',
        meta: { title: '服务项目', roles: ['sls_master_data_service_items'] }
      },
      {
        path: 'trailer_model',
        component: () => import('@/views/system-manager/trailerModel'),
        name: 'TrailerModel',
        meta: { title: '挂车型号', roles: ['sls_master_data_trailer_model'] }
      },
      {
        path: 'manufacturer',
        component: () => import('@/views/system-manager/manufacturer'),
        name: 'Manufacturer',
        meta: { title: '生产厂家', roles: ['sls_master_data_manufacturer'] }
      },
      {
        path: 'warranty',
        component: () => import('@/views/system-manager/warranty'),
        name: 'Warranty',
        meta: { title: '保修期', roles: ['sls_master_data_warranty'] }
      }
    ]
  },
  {
    path: '/system_manager',
    component: Layout,
    name: 'SystemManager',
    meta: {
      title: '平台设置',
      icon: 'el-icon-setting',
      roles: ['sls_settings']
    },
    children: [
      {
        path: 'base-set',
        component: () => import('@/views/system-manager/base-set'),
        name: 'BaseSet',
        meta: { title: '系统设置', roles: ['sls_settings_base'] }
      },
      {
        path: 'notice-template',
        component: () => import('@/views/system-manager/notice-template'),
        name: 'NoticeTemplate',
        meta: { title: '通知模板', roles: ['sls_settings_notice_template'] }
      }
    ]
  },
  // bigScreenRouter,
  // qrcodeManagerRouter,
  // 打印画面
  {
    path: '/qrcodeManager/print',
    component: () => import('@/views/qrcodeManager/print'),
    name: 'print',
    hidden: true,
    meta: { title: 'print' }
  },
  // customerMenuRouter,
  {
    path: '/report_form',
    component: Layout,
    redirect: '/report_form/report_fault_type',
    meta: {
      title: '统计报表',
      icon: 'table',
      roles: ['sls_report_form']
    },
    children: [
      {
        path: 'report_manufacturer',
        component: () => import('@/views/report-form/report-manufacturer'),
        name: 'ReportFormByManufacturer',
        meta: { title: '售后总结数据', roles: ['sls_report_form_manufacturer'] }
      },
      {
        path: 'report_fault_type',
        component: () => import('@/views/report-form/report-fault-type'),
        name: 'ReportFormByFaultType',
        meta: { title: '故障类型数据', roles: ['sls_report_form_fault_type'] }
      }
    ]
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
